import React, {Suspense, useContext, useEffect} from 'react';
// @ts-ignore
import {BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
// @ts-ignore
import { TransitionGroup, CSSTransition } from "react-transition-group";

import './i18n'

import DefaultLayout from './containers/defaultLayout/DefaultLayout';
import EconomicResearchContainer from "./containers/economicResearch/EconomicResearchContainer";
import GipDownloadContainer from "./containers/gipDownload/GipDownloadContainer";
import Constants from "./data/Constants";
import {HomeGip, HomeRoot} from "./containers/home/HomeContainer";
import RankingsAndLevels from "./containers/rankingAndLevels/RankingsAndLevelsContainer";
import DataService from "./services/DataService";
import './animations.css'

import { GlobalDataContext } from "./contexts/GlobalDataContext";
import { RankingsAndLevelsProvider } from "./contexts/RankingsAndLevelsContext";
import { RankingsAndLevelsMapProvider } from "./contexts/RankingsAndLevelsMapContext";

import NotFoundComponent from "./containers/Errors/NotFoundComponent";
import InternalErrorComponent from "./containers/Errors/InternalErrorComponent";
import BpsContainer from "./containers/bps/BpsContainer";
import MobileRoutes from './components/responsive/MobileRoutes';

 const Router: React.FC = () => {

    // @ts-ignore
    const { setData } = useContext(GlobalDataContext);

    useEffect( () => {
        const fetchData = async () => {
            // setData = (reportsAvailables: any, last10YearReports: any, lastAvailableReport: any)
            const [availableReports, last10YearReports, lastYearAvailable, bpsData] = await DataService.fetchInitialData();
            setData(availableReports, last10YearReports, lastYearAvailable, bpsData);
        };
        fetchData();
    }, []);

    return (
        <BrowserRouter basename={ process.env.REACT_APP_BASENAME || '' }>
            <Suspense fallback={ null }>
                <RankingsAndLevelsProvider>
                    <RankingsAndLevelsMapProvider>
                      <CustomRoutes />
                      <MobileRoutes />
                    </RankingsAndLevelsMapProvider>
                </RankingsAndLevelsProvider>
            </Suspense>
        </BrowserRouter>
    );
};

export default Router


// @ts-ignore
const CustomRoutes = withRouter(({ location }) => {
    // Allow /data/* requests to pass through to public content
    if (location.pathname.startsWith('/data/')) {
        return null;
    }

    return (
      <DefaultLayout>
          <Switch location={location}>
              <Route exact path={Constants.routes.root} component={EconomicResearchContainer} />
              <Route exact path={Constants.routes.menu} component={HomeRoot} />
              <Route exact path={Constants.routes.gip} component={HomeGip} />
              <Route path={Constants.routes.bps} component={BpsContainer} />
              <Route path={Constants.routes.rankings} component={RankingsAndLevels} />
              <Route exact path={Constants.routes.economicResearch} component={EconomicResearchContainer} />
              <Route path={Constants.routes.gipDownload} component={GipDownloadContainer} />

              <Route path={Constants.routes.error} component={InternalErrorComponent} />
              <Route path="*" component={NotFoundComponent} />
          </Switch>
      </DefaultLayout>
    )
});
